<template>
  <div>
<div class="businessintroduce-style" v-if="isMobile">
  <toppage></toppage>
  <div class="businessintroduce-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>数字资产合规处置</h1>
                        <p>
                            <span>10</span>亿级合规处置经验
                        </p>
                        <p>
                           <span>20+</span>司法处置案例 
                        </p>
                        <p>
                            海外合规持牌交易所处置虛拟币
                        </p>
                        <p>
                            外管局合法报备，合规结汇
                        </p>
                        <p> 根据合同打款至指定财政账户</p>
          </div>
        </div>
   <div class="main-profession">
    <h1>处置路径图</h1>
    <img src="@/assets/image/mobile/businessintroduce/chuzhilujing.png" alt="">
   </div>
        <footerpage></footerpage>
      </div>
      <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="../../assets/image/newhome/huidaodingbu.png" alt="">

</div>
    <div class="businessintroduce-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section businessintroduce-top  " >
          <div >

            <div class="businessintroduce-nav ">
              <navbar classname="businessintroduce" childclassname="businessintroducechild"></navbar>
            </div>
            <div class="section-content ">
              <div class="top-title">
                <div class="title-info">
                    <div class="left-content">

                        <h1>数字资产合规处置</h1>
                        <p>
                            <span>10</span>亿级合规处置经验
                        </p>
                        <p>
                           <span>20+</span>司法处置案例 
                        </p>
                        <p>
                            海外合规持牌交易所处置虛拟币
                        </p>
                        <p>
                            外管局合法报备，合规结汇
                        </p>
                        <p> 根据合同打款至指定财政账户</p>
                    </div>
                 
                </div>
                <!-- <div class="title-content">
             <img src="@/assets/image/newhome/businessintroduce/bannerbeijing.gif" alt="">
            </div> -->
          
              </div>
            </div>
          </div>
        </div>
     
      
       
        <div class="section businessintroduce-profession">
          <div class="profession-content animated-element1" v-show="isprofession">
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info  ">

                  <h1>处置路径图</h1>
                  <!-- <img src="../../assets/image/newhome/businessintroduce/chuzhilujing@2x.png" alt=""> -->
                </div>
            <div class="profession-liucheng">
              <!-- <img src="../../assets/image/newhome/businessintroduce/neirong.png" alt=""> -->
              <!-- <div class="liucheng-content">
                <span >业务沟通</span>
                <span>项目评估</span>

                <span>支付费用</span>
                <span>安全审计</span>

                <span>出具报告</span>

              </div> -->
            </div>
            <!-- <div class="liucheng-button">
              <span>联系我们</span>
            </div> -->
              </div>
           
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </div>
  </template>
  <script>
  import navbar from "@/components/navbar.vue";
  import newfooter from "@/components/newfooter.vue";
  // import countTo  from 'vue-count-to';
  // import CountUp from "countup"
  import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";
  export default {
    components: {
      navbar,
      newfooter,
      // countTo 
      toppage,
      footerpage
    },
    data() {
      return {
        deviceType: this.getDeviceType(),
        showButton: false,
      scrollThreshold: 400,
   isMobile: false,
        // isshebi:false,
        iscorebusiness1:false,
        iscorebusiness2:false,
        isprofession:false,
        screenWidth: 0,
        bannerHeight: 0,
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          //是否显示导航，默认为false
          navigation: true,
   afterLoad: this.afterLoad,
   onLeave:this.onLeave,

          //为每个section设置背景色
          // sectionsColor: [
          //     "#41b883",
          //     "#ff5f45",
          //     "#0798ec",
          //     "#fec401",
          //     "#1bcee6",
          //     "#ee1a59",
          //     "#2c3e4f",
          //     "#ba5be9",
          //     "#b4b8ab"
          // ],
        },
      };
    },
    methods: {
      scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
      getDeviceType() {
      return window.innerWidth < 768 ? "手机" : "电脑";
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
      afterLoad(anchorLink,index) {
        console.log(anchorLink,index);
          console.log("Emitted 'after load' event.")
          //获取body的classname，跟随section滑动刷新
          let a = document.body.className
          console.log(a);
          //在第几页控制相关逻辑
        //   if(a !== 'fp-scroll-mac fp-viewing-0' || a !== 'fp-viewing-0'){
        //     this.isshebi=false
        //   }
  
          if(a !== 'fp-scroll-mac fp-viewing-1' || a !== 'fp-viewing-1'){
            this.isprofession=false
          }
          if (a === 'fp-scroll-mac fp-viewing-1' || a === 'fp-viewing-1') {
            // console.log(eee);
            this.isprofession=true
     
        }
        // else if(a === 'fp-scroll-mac fp-viewing-0' || a === 'fp-viewing-0'){
        //   this.isshebi=true
        // }
        },
  
   
      next() {
        // 向下滚动一页
        this.$refs.fullpage.api.moveSectionUp();
// this.$refs.fullpage.goTo(0);
      },
    },
    // created(){     location.reload()},
    mounted() {
      if (this.deviceType != "手机" && !this.isMobile) {
      this.next();
    }
    if(this.isMobile){

window.addEventListener('scroll', () => {
  this.showButton = window.scrollY > this.scrollThreshold;
});
}
      // 首次加载时,初始化高度
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (450 / 1450) * this.screenWidth;
      // 窗口大小发生改变
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
        this.bannerHeight = (450 / 1450) * this.screenWidth;
      };
      
    },
    created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', () => {});
  },
  };
  </script>
  <style>
  .fp-warning,
  .fp-watermark {
    display: none !important;
  }
  </style>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/businessintroduce.scss";
  </style>
  